import { Box, Link, Typography } from "@mui/material";
import { HeaderBlock } from "@colliers/colliers-b2c";

const TermsOfUse = () => {
  return (
    <>
      <HeaderBlock title="Terms of Use" />
      <Box className="main-content display-flex">
        <Box
          className="margin-auto"
          sx={{ flexWrap: "wrap", width: { xs: "100%", md: "75%", lg: "50%" } }}
        >
          <Box className="container" sx={{ py: 4 }}>
            <Typography mb={2}>
              We have set up some ground rules to ensure that we keep this area
              useful, informative and safe for everyone. This application is
              built on trust, and this Agreement helps promote that trust among
              all Users of our service. THIS AGREEMENT DESCRIBES THE TERMS AND
              CONDITIONS UNDER WHICH YOU WILL USE THE SERVICES PROVIDED BY THE
              COLLIERS SECURE SHARE APPLICATION (THE &quot;APPLICATION&quot;). BY
              USING THE APPLICATION YOU AGREE TO ALL OF THE TERMS AND CONDITIONS
              SET OUT IN THIS AGREEMENT. IF YOU DO NOT AGREE WITH ANY OF THE
              TERMS AND CONDITIONS SET OUT IN THIS AGREEMENT, PLEASE DO NOT USE
              THE APPLICATION. Colliers reserves the right to change these
              guidelines and disclaimers at anytime, and you agree that each
              visit you make to the Application shall be subject to the current
              guidelines. If you have any questions that this guide does not
              answer, please email{" "}
              <Link href="mailto:contact@colliers.com?subject=Contact from Colliers Secure Share Terms of Use Page">
                contact@colliers.com
              </Link>
              {"."}
            </Typography>
            <Typography mb={4}>
              --------------------------------------------------------------------------------
            </Typography>
            <Typography mb={2} sx={{ fontWeight: 600 }}>
              1. Defined Terms
            </Typography>
            <Typography mb={4}>
              In this Agreement, the following words or expressions have the
              following meanings: Colliers shall include any subsidiaries,
              parent companies affiliates, officers or employees thereof and any
              Internet services operated by Colliers International Property
              Consultants, Inc., Colliers International Group Inc. and any
              related or affiliated companies. &quot;Colliers
              International&quot; means the network of independent member
              companies known as Colliers International Property Consultants.
            </Typography>
            <Typography mb={4}>
              &quot;Personal Information&quot; means information by which others
              might identify you, such as your name or your contact information,
              which you may provide to Colliers.com from time to time.
              &quot;User&quot; means any user of the Colliers.com service.
            </Typography>
            <Typography mb={2} sx={{ fontWeight: 600 }}>
              2. Disclaimer
            </Typography>
            <Typography mb={4}>
              Colliers International is a network of member firms of Colliers
              International Property Consultants, each of which is a separate
              and independent legal entity.
            </Typography>
            <Typography mb={4}>
              The information contained in this Application is for general
              guidance on matters of interest only. The application and impact
              of laws can vary widely based on the specific facts involved.
              Given the changing nature of laws, rules and regulations, and the
              inherent hazards of electronic communication, there may be delays,
              omissions or inaccuracies in information contained in the
              Application. Accordingly, the Application should not be used as a
              substitute for consultation with a licensed commercial real estate
              broker or other competent advisers. Before making any decision or
              taking any action, you should consult a Colliers International
              professional.
            </Typography>
            <Typography mb={4}>
              Colliers International is not responsible for any errors or
              omissions, or for the results obtained from the use of this
              information. All information in this Application is provided
              &quot;as is&quot;, with no guarantee of completeness, accuracy,
              timeliness or of the results obtained from the use of this
              information, and without warranty of any kind, express or implied,
              including, but not limited to warranties of performance,
              merchantability and fitness for a particular purpose. In no event
              will CIPC, Colliers International Group Inc., Colliers
              International, its member firms, or the partners, directors,
              officers, owners, agents or employees thereof be liable to you or
              anyone else for any decision made or action taken in reliance on
              the information in the Application or for any consequential,
              special or similar damages, even if advised of the possibility of
              such damages.
            </Typography>
            <Typography mb={4}>
              Certain links in this Application connect to other sites or
              applications maintained by third parties over whom Colliers
              International has no control. Colliers International makes no
              representations as to the accuracy or any other aspect of
              information contained in other Web sites or applications and does
              not undertake any obligation to update the materials on any such
              Web sites.
            </Typography>
            <Typography mb={2} sx={{ fontWeight: 600 }}>
              3. Disputes
            </Typography>
            <Typography mb={4}>
              In the event that you have a dispute with one or more other users
              of the Applications, you release Colliers (and our agents and
              employees) from claims, demands and damages (actual and
              consequential) of every kind and nature, known and unknown,
              suspected and unsuspected, disclosed and undisclosed, arising out
              of or in any way connected with such disputes.
            </Typography>
            <Typography mb={2} sx={{ fontWeight: 600 }}>
              4. Limit on Liability
            </Typography>
            <Typography mb={4}>
              In no event shall Colliers or its suppliers be liable for lost
              profits or any special, incidental or consequential damages
              (however arising, under contract, tort or any other theory of
              liability) arising out of or in connection with the use of the
              Application. Our liability, and the liability of our suppliers, to
              you or to any third parties in any circumstance arising from your
              use of the Application or any of its information, features, or
              content is limited to US$1,000.
            </Typography>
            <Typography mb={2} sx={{ fontWeight: 600 }}>
              5. System Integrity
            </Typography>
            <Typography mb={4}>
              You as a User agree not to use any device, software or routine to
              interfere or attempt to interfere with the proper operation of
              Application. If you are issued a password, you agree not to
              disclose your password to any third party or to use your password
              for any unauthorized purpose.
            </Typography>
            <Typography mb={2} sx={{ fontWeight: 600 }}>
              6. Web Links
            </Typography>
            <Typography mb={4}>
              The Application may display URLs or icons which allow Users to
              link to other web sites, including, without limitation, sites
              which are operated by third parties and which are not maintained
              by Colliers. Collier makes no representations whatsoever about any
              other web site to which you may have access through the
              Application. Any content, services, representations or warranties
              made on such other web sites are the sole responsibility of the
              operator of those sites, and Colliers assumes no responsibility
              for any the content, the operation or the services provided
              thereon.
            </Typography>
            <Typography mb={2} sx={{ fontWeight: 600 }}>
              7. Limited License
            </Typography>
            <Typography mb={4}>
              The materials on this Application are subject to confidentiality
              obligations. Except as stated herein, NONE of the material may be
              copied, reproduced, distributed, republished, downloaded,
              displayed, posted, or transmitted in any form or by any means,
              including but not limited to, electronic, mechanical,
              photocopying, recording, or otherwise, without the prior written
              permission of Colliers. Upon termination, you must immediately
              destroy any downloaded and printed materials. Any unauthorized use
              of any material found on the Application may violate copyright
              laws, trademark laws, confidentiality obligations the laws of
              privacy and publicity, and communications regulations and
              statutes.
            </Typography>
            <Typography mb={2} sx={{ fontWeight: 600 }}>
              8. Privacy Policy
            </Typography>
            <Typography mb={4}>
              Our current privacy policies may be viewed by clicking the
              &quot;Privacy Policy&quot; link at the bottom of the Application
              page and shall form part of this Terms of Use Agreement.
            </Typography>
            <Typography mb={4}>
              PLEASE NOTE THAT, AS PART OF OUR PRIVACY POLICY, COLLIERS.COM DOES
              RESERVE THE RIGHT TO TAKE ANY ACTION WITH RESPECT TO YOUR PERSONAL
              INFORMATION THAT WE, IN OUR SOLE AND ABSOLUTE DISCRETION, DEEM
              NECESSARY OR APPROPRIATE IF SUCH INFORMATION MAY CREATE A
              LIABILITY FOR US OR MAY CAUSE US TO LOSE ALL OR PART OF THE
              SERVICES PROVIDED TO US BY OUR INTERNET SERVICE PROVIDERS OR OTHER
              SUPPLIERS.
            </Typography>
            <Typography mb={2} sx={{ fontWeight: 600 }}>
              9. Indemnification
            </Typography>
            <Typography mb={4}>
              You as a User agree to indemnify and hold harmless Colliers from
              any claim or demand made by any third party arising out of the use
              of the services provided by the Application by you or by any other
              person using your User name and password. You also agree to
              indemnify and hold harmless Colliers against all of the reasonable
              costs of defending any such third party claims.
            </Typography>
            <Typography mb={2} sx={{ fontWeight: 600 }}>
              10. No Warranty
            </Typography>
            <Typography mb={4}>
              WE PROVIDE THE APPLICATION AND OUR SERVICES &quot;AS IS&quot; AND
              WITHOUT ANY WARRANTY OR CONDITION, EXPRESS OR IMPLIED. WE AND OUR
              SUPPLIERS SPECIFICALLY DISCLAIM THE IMPLIED WARRANTIES OF TITLE,
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, EXPECTATION OF
              PRIVACY AND NON-INFRINGEMENT.
            </Typography>
            <Typography mb={4}>
              WITHOUT LIMITING THE FOREGOING, COLLIERS MAKES NO WARRANTY THAT
              (I) THE SERVICES AND MATERIALS WILL MEET YOUR REQUIREMENTS, (II)
              THE SERVICES WILL BE UNINTERRUPTED, SECURE, OR ERROR-FREE, OR
              (III) THE CONTENT OBTAINED FROM THE USE OF THE SERVICES WILL BE
              EFFECTIVE, ACCURATE OR RELIABLE.
            </Typography>
            <Typography mb={2} sx={{ fontWeight: 600 }}>
              11. General Compliance with Laws
            </Typography>
            <Typography mb={4}>
              You as a User agree to comply with all applicable laws, statutes,
              ordinances and regulations regarding your use of our service.
            </Typography>
            <Typography mb={2} sx={{ fontWeight: 600 }}>
              12. Applicable Law
            </Typography>
            <Typography mb={4}>
              This Terms of Use Agreement shall be governed by the laws of the
              State of Delaware, USA, and the parties hereby irrevocably attorn
              to the jurisdiction of the courts of the State of Delaware.
            </Typography>
            <Typography mb={2} sx={{ fontWeight: 600 }}>
              13. Severability
            </Typography>
            <Typography mb={4}>
              If any provision of this Agreement shall be held to be invalid,
              illegal or unenforceable, the validity, legality or enforceability
              of the remaining provisions of this Agreement shall not in any way
              be affected or impaired thereby.
            </Typography>
            <Typography mb={2} sx={{ fontWeight: 600 }}>
              14. Entire Agreement and Waiver
            </Typography>
            <Typography mb={4}>
              This Agreement constitutes the entire agreement between the
              Colliers and the User and supersedes all prior agreements,
              understandings, negotiations and discussions, whether oral or
              written, between the parties with respect thereto. No supplement,
              modification, waiver or termination of this Agreement shall be
              binding unless executed in writing by the person to be bound
              thereby or otherwise agreed in the course of using the
              Application. No waiver of any of the provisions of this Agreement
              shall constitute or be deemed a waiver of any other provisions
              (whether or not similar) or a continuing waiver unless otherwise
              expressly provided.
            </Typography>
            <Typography mb={2} sx={{ fontWeight: 600 }}>
              15. Additional Information
            </Typography>
            <Typography>
              For any questions regarding this statement, please contact us at{" "}
              <Link href="mailto:contact@colliers.com?subject=Contact from Colliers Secure Share Terms of Use Page">
                contact@colliers.com
              </Link>
              {"."}
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default TermsOfUse;
